import { useTranslation } from 'next-i18next'
import styles from './NoCarFound.module.scss'
import React from 'react'
import ContactInfo from '../ContactInfo/ContactInfo'
import Button from '@/components/buttons/Button/Button'
import Alert from '@mui/material/Alert'

type Props = {
  onClickCarPicker: () => void
}

const NoCarFound = (props: Props) => {
  const { t } = useTranslation('shop')

  return (
    <div className={styles.component}>
      <div className={styles.title}>
        <Alert severity="error">{t('unableToFindCarTitle')}</Alert>
      </div>
      <div className={styles.subtitle}>
        <p>{t('unableToFindCarDescription')}</p>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <Button
            rounded={true}
            onClick={props.onClickCarPicker}
            label={t('selectCarManually')}
            large={true}
          />
          <div className='margin-top-1'>
            <ContactInfo />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoCarFound